const columns = (onEdit, onRemove) =>  [
	{
		headerName: "Sub-category Image",
		field: "media",
		renderCell: ({ row }) => (
			<div>
				<img src={row.media} alt="" style={{ height: "50px", width: "50px" }} />
			</div>
		),
	},
	{
		headerName: "Sub Category",
		field: "subCategory",
		renderCell: ({ row }) => <div>{row.name}</div>,
	},
	{
		headerName: "Action",
		field: "action",
		renderCell: ({ row }) => (
			<div className="flex gap-4">
				<span className="text-theme cursor-pointer" onClick={() => onEdit(row)}>Edit</span>
				{/* <span className="text-theme cursor-pointer" onClick={() => onRemove(row)}>Remove</span> */}
			</div>
		),
	},
];

const onClick: any = (params: any) => {};
const categoryDetaildata = (categories: any[], onEdit = (e) => {}, onRemove = (e) => {}) => ({
	columns: columns(onEdit, onRemove),
	rows: categories,
	onClick,
});

export default categoryDetaildata;
